"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SingpassAccess;
(function (SingpassAccess) {
    SingpassAccess["Denied"] = "denied";
    SingpassAccess["Error"] = "error";
    SingpassAccess["Granted"] = "granted";
    SingpassAccess["Pending"] = "pending";
})(SingpassAccess = exports.SingpassAccess || (exports.SingpassAccess = {}));
